import { Box } from "@mui/material";
import { StoryAvatar } from "Components/Stories/StoryAvatar";
import type { StoryGroup } from "Components/Stories/StoriesSection";
import type { ReactNode } from "react";

type Props = {
  storyGroups: Array<StoryGroup>;
  onSelect: (actorId: string) => void;
  /** Rendered before the story groups — the current persona's own-story circle. */
  ownStorySlot?: ReactNode;
  /** Rendered after the own circle — the grayed Mo.one circle when no story groups are live. */
  placeholderSlot?: ReactNode;
};

export const StoriesBar = ({
  storyGroups,
  onSelect,
  ownStorySlot,
  placeholderSlot,
}: Props) => {
  return (
    <Box
      sx={{
        display: "flex",
        // 16px between circles — StoriesBarSkeleton mirrors this gap.
        gap: 4,
        overflowX: "auto",
        py: 1,
        px: 0.5,
        "&::-webkit-scrollbar": { display: "none" },
        scrollbarWidth: "none",
      }}
    >
      {ownStorySlot}
      {placeholderSlot}
      {storyGroups.map((group) => (
        <StoryAvatar
          key={group.actorId}
          name={group.actorName}
          imageUrl={group.actorImage}
          authorKind={group.authorKind}
          ringVariant={group.isRead ? "read" : "unread"}
          onClick={() => onSelect(group.actorId)}
        />
      ))}
    </Box>
  );
};
